/** A deploy replaced the chunk this old build asks for: retries can't succeed, only a reload recovers. */
export function isChunkLoadError(error: unknown): error is Error {
    if (!(error instanceof Error)) {
        return false;
    }
    if (error.name === 'ChunkLoadError') {
        return true;
    }
    return CHUNK_LOAD_ERROR_MESSAGES.some((message) => error.message.includes(message));
}

// A plain `TypeError` in browsers, so only its message, worded differently by each, tells a chunk load apart.
const CHUNK_LOAD_ERROR_MESSAGES = [
    // Chromium
    'Failed to fetch dynamically imported module',
    // Firefox
    'error loading dynamically imported module',
    // Safari
    'Importing a module script failed',
    // Vite's preload helper, when the stylesheet of a chunk is missing
    'Unable to preload CSS',
];
